import { APP, NO_CALL } from "../../constants";

const PARAMETER_KEYS = {
  KEYWORDS: "keywords",
  CATEGORY: "category",
  LIST_SIZE: "list-size",
  PAGE_NUMBER: "page-number",
  ITEM: "item",
  ITEM_WHITELIST: "item-whitelist",
  PARENT_ITEM: "parent-item",
  AVAILABILITY: "availability",
  PRICE: "price",
  LIST_PRICE: "list-price",
  QUANTITY: "quantity",
  TRANSACTION_ID: "transaction-id"
};

const REQUIRED_PARAMETERS = {
  [APP.HOMEPAGE]: {
    [NO_CALL.displayAds]: [PARAMETER_KEYS.CATEGORY]
  },
  [APP.SEARCH]: {
    [NO_CALL.sponsoredProducts]: [
      PARAMETER_KEYS.PAGE_NUMBER,
      PARAMETER_KEYS.LIST_SIZE,
      PARAMETER_KEYS.KEYWORDS,
      PARAMETER_KEYS.ITEM_WHITELIST
    ],
    [NO_CALL.displayAds]: [
      PARAMETER_KEYS.PAGE_NUMBER,
      PARAMETER_KEYS.LIST_SIZE,
      PARAMETER_KEYS.KEYWORDS
    ]
  },
  [APP.CATEGORY]: {
    [NO_CALL.sponsoredProducts]: [
      PARAMETER_KEYS.PAGE_NUMBER,
      PARAMETER_KEYS.LIST_SIZE,
      PARAMETER_KEYS.CATEGORY,
      PARAMETER_KEYS.ITEM_WHITELIST
    ],
    [NO_CALL.displayAds]: [
      PARAMETER_KEYS.PAGE_NUMBER,
      PARAMETER_KEYS.LIST_SIZE,
      PARAMETER_KEYS.CATEGORY
    ]
  },
  [APP.PDP]: {
    [NO_CALL.displayAds]: [
      PARAMETER_KEYS.PARENT_ITEM,
      PARAMETER_KEYS.AVAILABILITY,
      PARAMETER_KEYS.PRICE,
      PARAMETER_KEYS.LIST_PRICE
    ]
  },
  [APP.ORDER_CONFIRMATION]: {
    [NO_CALL.displayAds]: [
      PARAMETER_KEYS.ITEM,
      PARAMETER_KEYS.PARENT_ITEM,
      PARAMETER_KEYS.PRICE,
      PARAMETER_KEYS.QUANTITY,
      PARAMETER_KEYS.TRANSACTION_ID
    ]
  }
};

const getRequiredParameters = (app, nocall = null) => {
  const appRequiredParameters = REQUIRED_PARAMETERS[app];

  if (nocall === null) {
    return Array.from(
      new Set([
        ...(appRequiredParameters[NO_CALL.displayAds] || []),
        ...(appRequiredParameters[NO_CALL.sponsoredProducts] || [])
      ])
    );
  }

  return appRequiredParameters[nocall] || [];
};

export default getRequiredParameters;
